import React from 'react';
import { Confirmation } from '../confirmation/confirmation';
import { useTranslation } from 'react-i18next';

export const Completed = () => {
    // eslint-disable-next-line
    const { t, i18n } = useTranslation('static');

    return <Confirmation title={t('completed_ride')} message={<div>{t('ride_not_found')}</div>} />;
};
